export enum Domain {
  Imperium = "Imperium",
  Ishtar = "Ishtar",
  both = "Obie",
  unknown = "Nieznana",
}
